import { h } from 'preact'

import styles from './ChartContainer.module.scss'

export default function ChartContainer({
  children,
  edit,
  reset,
  message = null,
}) {
  return (
    <div className={styles.ChartPage}>
      <div className={styles.ChartHeader}>
        <div>{message}</div>
        <div className={styles.ChartHeaderButtons}>
          <button onClick={reset}>Reset</button>
          <button onClick={edit}>Edit</button>
          <button onClick={() => window.print()}>Print</button>
        </div>
      </div>

      <div className={styles.ChartContainer}>{children}</div>
    </div>
  )
}
